export default __webpack_public_path__ + "static/media/reload.icon.22adf063.svg";